import { lazy } from "react";

export const ConnectedProviderSignInLazy = lazy(
  () => import("./ConnectedProviderSignIn")
);
